// Выбор модели: opus / sonnet / haiku или произвольный идентификатор.
import { useState } from 'react'
import { cx } from './ui.tsx'

const PRESETS: { id: string; label: string }[] = [
  { id: 'opus', label: 'Opus — сложные задачи' },
  { id: 'sonnet', label: 'Sonnet — основная' },
  { id: 'haiku', label: 'Haiku — быстрые мелочи' },
]
const CUSTOM = '__custom'

export function ModelInput({
  value,
  onChange,
  id,
  emptyLabel,
  className,
}: {
  value: string
  onChange: (v: string) => void
  id?: string
  /** Если задано — разрешено пустое значение («по умолчанию»). */
  emptyLabel?: string
  className?: string
}) {
  const isPreset = PRESETS.some((p) => p.id === value) || (emptyLabel !== undefined && value === '')
  const [custom, setCustom] = useState(!isPreset)
  return (
    <div className={cx('flex gap-2', className)}>
      <select
        id={id}
        className="ctl"
        value={custom ? CUSTOM : value}
        onChange={(e) => {
          if (e.target.value === CUSTOM) {
            setCustom(true)
            return
          }
          setCustom(false)
          onChange(e.target.value)
        }}
      >
        {emptyLabel !== undefined ? <option value="">{emptyLabel}</option> : null}
        {PRESETS.map((p) => (
          <option key={p.id} value={p.id}>
            {p.label}
          </option>
        ))}
        <option value={CUSTOM}>Другая модель…</option>
      </select>
      {custom ? (
        <input
          className="ctl font-mono"
          value={value}
          onChange={(e) => onChange(e.target.value.trim())}
          placeholder="например, claude-opus-5-5"
          aria-label="Идентификатор модели"
        />
      ) : null}
    </div>
  )
}
